import {
    ImageBackground, Keyboard, Platform,
    Pressable, Text,
    TextInput,
    TouchableWithoutFeedback,
    View
} from "react-native";
import React from "react";
import { useForm, Controller } from "react-hook-form";

import {styles} from "../common/styles";
import {API_URL} from "../common/constants";
import {ActivityIndicatorView} from "../common/ActivityIndicatorView";
import {KeyboardAvoidingViewWrapper} from '../common/KeyboardAvoidingViewWrapper'
import {i18n} from "../common/localization";
import {FlagHeader} from "../common/FlagHeader";

import bg from "../assets/main-bg.jpg";
import EyeSlashIcon from "../icons/EyeSlashIcon";
import EyeIcon from "../icons/EyeIcon";
import {ShownWithKeyboardView} from "../common/ShownWithKeyboardView";

export const Login = ({ navigation, saveAccountData }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [authError, setAuthError] = React.useState("");
    const [hidePass, setHidePass] = React.useState(true);

    const { control, handleSubmit, formState: { errors } } = useForm({
        //defaultValues: {
        //    login: Platform.OS === 'web' ? 'vela.2' : '',
        //    password: Platform.OS === 'web' ? 'vela.two' : ''
        //}
    });

    function onPressLogin(data) {
        //if (Platform.OS === 'web') {
        //    saveAccountData("User");
        //    return;
        //}

        setIsLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "username": data.login,
                "password": data.password,
                "rememberMe": true
            })
        };
        fetch(API_URL + "/authenticate", requestOptions)
            .then((response) => response.json())
            .then((authResult) => {
                setIsLoading(false);
                const token = authResult["id_token"];
                if (token !== undefined) {
                    fetch(API_URL + "/account", {headers: { 'Authorization': 'Bearer ' + token }})
                        .then((response) => response.json())
                        .then((accountResult) => {
                            saveAccountData(accountResult, token);
                        })
                        .catch(() => {
                            setAuthError(i18n.t("incorrectLoginPassword"));
                        });
                } else {
                    setAuthError(i18n.t("incorrectLoginPassword"));
                }
            })
            .catch(() => {
                setIsLoading(false);
            });
    }

    {/*Signup is switched off until the backend is ready*/}
    // function onPressSignUp() {
    //     navigation.navigate('SignUp');
    // }

    function onPressRecoveryPassword() {
        navigation.navigate('RecoveryPassword');
    }

    const content = (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="cover" style={styles.bgImageContainer}>
                <KeyboardAvoidingViewWrapper style={styles.login.mainViewContainer}>
                    <View style={{flex: 1, justifyContent: "center"}}>
                        <FlagHeader/>
                        { Platform.OS === 'ios' && <ShownWithKeyboardView /> }
                        <View>

                            <View style={styles.login.inputContainer}>
                                <Controller
                                    control={control}
                                    rules={{
                                        required: Platform.OS !== 'web',
                                    }}
                                    render={({ field: { onChange, onBlur, value } }) => (
                                        <TextInput
                                            style={styles.login.input}
                                            onChangeText={onChange}
                                            onBlur={onBlur}
                                            value={value}
                                            placeholder={i18n.t("login")}
                                            placeholderTextColor="white"
                                            cursorColor="white"
                                            color="white"
                                            keyboardType="default"
                                            autoComplete="username"
                                            autoCapitalize="none"
                                            autoCorrect={false}
                                        />
                                    )}
                                    name="login"
                                />
                                { errors.login && <Text style={styles.errorText}>{i18n.t("enterEmail")}</Text> }
                                { authError !== "" && <Text style={styles.errorText}>{authError}</Text> }
                            </View>
                            <View style={styles.login.inputContainer}>
                                <Controller
                                    control={control}
                                    rules={{
                                        required: Platform.OS !== 'web',
                                    }}
                                    render={({ field: { onChange, onBlur, value } }) => (
                                        <View>
                                            <TextInput
                                                style={styles.login.input}
                                                onChangeText={onChange}
                                                value={value}
                                                onBlur={onBlur}
                                                placeholder={i18n.t("password")}
                                                placeholderTextColor="white"
                                                cursorColor="white"
                                                color="white"
                                                secureTextEntry={hidePass}
                                                keyboardType="default"
                                            />
                                            {/* TODO: Change to icon */}
                                            <Pressable style={styles.login.showPasswordIcon} onPress={() => setHidePass(!hidePass)}>
                                                {hidePass? <EyeSlashIcon /> : <EyeIcon />}
                                            </Pressable>
                                        </View>
                                    )}
                                    name="password"
                                />

                                { errors.password && <Text style={styles.errorText}>{i18n.t("enterPassword")}</Text> }
                            </View>
                            <View style={styles.login.buttonContainer}>
                                <Pressable onPress={handleSubmit(onPressLogin)} style={styles.login.button}>
                                    <View style={styles.login.arrowLine} />
                                    <View style={styles.login.arrowHead} />
                                </Pressable>
                            </View>
                            <View style={styles.login.buttonContainer}>
                                <Pressable onPress={onPressRecoveryPassword} color={"none"} style={styles.login.signUpButton}>
                                    <Text style={styles.login.signUpButtonText}>{i18n.t("recoverPassword")}</Text>
                                </Pressable>
                            </View>
                            {/*Signup is switched off until the backend is ready*/}
                            {/*<View style={styles.login.buttonContainer}>*/}
                            {/*    <Pressable onPress={onPresSignUp} color={"none"} style={styles.login.signUpButton}>*/}
                            {/*        <Text style={styles.login.signUpButtonText}>{i18n.t("signUp")}</Text>*/}
                            {/*    </Pressable>*/}
                            {/*</View>*/}
                        </View>
                    </View>
                </KeyboardAvoidingViewWrapper>
                <ActivityIndicatorView isVisible={isLoading} />
            </ImageBackground>
        </View>
    );

    return Platform.OS === 'web' ? (
        content
    ) : (
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
            {content}
        </TouchableWithoutFeedback>
    );
}
